module.exports = __webpack_public_path__ + "static/media/Talonflame_gaussian2.6ec9f670.png";